<template>
	<div class="pa">
		<div class="pa-switch" :class="{ 'pa-switch--on': popup.enabled }">
			<v-icon :color="popup.enabled ? 'primary' : 'grey'" class="mr-3">mdi-message-alert-outline</v-icon>
			<div class="pa-switch-text">
				<div class="pa-switch-label">Mostra il popup all'apertura del sito</div>
				<div class="pa-muted">Compare in ogni pagina, una sola volta per visitatore, e si chiude con il pulsante Chiudi</div>
			</div>
			<v-switch v-model="popup.enabled" color="primary" hide-details class="mt-0 pt-0 ml-2" />
		</div>

		<template v-if="popup.enabled">
			<div class="pa-row">
				<v-text-field
					v-model.number="popup.delay"
					type="number"
					min="0"
					label="Dopo quanti secondi"
					suffix="secondi"
					prepend-inner-icon="mdi-timer-outline"
					outlined
					dense
					hide-details
					class="pa-delay"
				/>
				<div class="pa-switch pa-switch--small" :class="{ 'pa-switch--on': popup.newsletter }">
					<v-icon :color="popup.newsletter ? 'primary' : 'grey'" class="mr-3">mdi-email-newsletter</v-icon>
					<div class="pa-switch-text">
						<div class="pa-switch-label">Form di iscrizione alla newsletter</div>
						<div class="pa-muted">Sotto il testo il visitatore può lasciare la sua email</div>
					</div>
					<v-switch v-model="popup.newsletter" color="primary" hide-details class="mt-0 pt-0 ml-2" />
				</div>
			</div>

			<div class="pa-testi">
				<div class="pa-head">
					<span class="pa-title">Testo del popup</span>
					<v-spacer></v-spacer>
					<template v-if="tab > 0 && popup.trans[tab]">
						<v-btn x-small text color="primary" title="Riporta il testo della prima lingua" @click="$emit('copia', tab)"
							><v-icon left x-small>mdi-clipboard-multiple-outline</v-icon>Copia dalla prima lingua</v-btn
						>
						<v-btn x-small text color="primary" @click="$emit('traduci', tab, popup.trans[tab].lang)">
							<v-avatar size="14px" tile class="mr-1"><v-img :src="require('@/assets/images/Google_Translate_logo.svg')" /></v-avatar>Traduci
						</v-btn>
					</template>
				</div>
				<v-tabs v-model="tab" show-arrows height="36" class="pa-tabs">
					<v-tab v-for="(t, key) in popup.trans" :key="t.lang" class="pa-tab">
						<v-avatar size="14px" tile class="mr-2"><img :src="bandiera(t.lang)" :alt="t.lang" /></v-avatar>
						{{ String(t.lang).toUpperCase() }}
						<span v-if="key === 0" class="pa-default">predefinita</span>
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab" class="pa-items">
					<v-tab-item v-for="t in popup.trans" :key="t.lang" eager>
						<div class="mt-3">
							<ckeditor v-model="t.text" :editor="editor" :config="editorConfig" />
						</div>
					</v-tab-item>
				</v-tabs-items>
				<div class="pa-muted mt-2">Se una lingua resta vuota, il sito mostra il testo della lingua predefinita.</div>
			</div>
		</template>
	</div>
</template>

<script>
// popup mostrato all'apertura del sito pubblico (layout.popup); CKEditor e' registrato dal genitore con Vue.use
export default {
	name: 'PopupApertura',
	props: {
		// { enabled, delay, newsletter, version, trans: [{ lang, text }] }
		popup: { type: Object, required: true },
		editor: { type: Function, required: true },
		editorConfig: { type: Object, required: true },
	},
	data() {
		return { tab: 0 };
	},
	methods: {
		bandiera(lang) {
			try {
				return require(`@/assets/images/flag/${String(lang).toUpperCase()}.svg`);
			} catch (e) {
				return require('@/assets/images/flag/map.svg');
			}
		},
	},
};
</script>

<style scoped>
.pa-switch {
	display: flex;
	align-items: center;
	padding: 10px 12px;
	border: 1px solid #e1e7ef;
	border-radius: 10px;
	background: #fff;
}
.pa-switch--on {
	border-color: #9fb6d3;
	background: #f7faff;
}
.pa-switch--small {
	flex: 1 1 320px;
}
.pa-switch-text {
	flex: 1 1 auto;
	min-width: 0;
}
.pa-switch-label {
	font-size: 14px;
	font-weight: 600;
	color: #1f2d3d;
}
.pa-muted {
	font-size: 12px;
	color: #5f6b7a;
}
.pa-row {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 10px;
	margin-top: 12px;
}
.pa-delay {
	flex: 0 0 220px;
}
.pa-testi {
	margin-top: 12px;
	padding: 10px 12px 12px;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	background: #fafbfd;
}
.pa-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
}
.pa-title {
	font-size: 12px;
	font-weight: 600;
	color: #5f6b7a;
}
.pa-tabs {
	border-bottom: 1px solid #e1e7ef;
}
.pa-tabs ::v-deep .v-tabs-bar {
	background: transparent !important;
}
.pa-tab {
	text-transform: none;
	letter-spacing: 0;
	font-weight: 600;
	min-width: 64px;
	font-size: 12px;
}
.pa-default {
	font-size: 10px;
	font-weight: 500;
	text-transform: uppercase;
	color: #5f6b7a;
	margin-left: 6px;
}
.pa-items {
	background: transparent !important;
}
@media (max-width: 768px) {
	.pa-delay {
		flex: 1 1 100%;
	}
}
</style>
